import { render } from "./editActivity.vue?vue&type=template&id=54ad662d"
import script from "./editActivity.vue?vue&type=script&lang=js"
export * from "./editActivity.vue?vue&type=script&lang=js"

import "./editActivity.vue?vue&type=style&index=0&id=54ad662d&lang=less"
script.render = render

export default script